import React, { useContext } from 'react';
import StepWizard from 'react-step-wizard';
import classNames from 'classnames';
import { Stepper } from '../components/Stepper';
import { HexpertChooseType } from './HexpertChooseType';
import { WeFitFormHeaderBlock } from '../blocks/WeFitFormHeaderBlock';
import { HexpertContext, HexpertState } from '../contexts/HexPertProvider';

import HexpertResultPage from './HexpertResultPage';
import { FormSection } from '../components/Form';
import { PageSections } from '../types/hexpertTypes';
import './HexpertSteps.scss';

let custom = {
  enterRight: 'c-hex-wizard-fade-in ',
  enterLeft: 'c-hex-wizard-fade-in',
  exitRight: 'c-hex-wizard-fade-out',
  exitLeft: 'c-hex-wizard-fade-out',
  intro: 'c-hex-wizard-fade-in',
};

const formSections: Function = (sections: PageSections[], action): JSX.Element[] => { 

  return sections.map((section, i) => { 
    return (
      <FormSection
        title={section.title || section?.label}
        description={section?.description}
        setStartSteps={action}
        formHeader={<WeFitFormHeaderBlock />} // need to add in backend should maybe be in the separator block?
        questions={section?.questions}
        label={section?.label}
        key={section?.label}
        showNextButton={i <= sections?.length - 1}
        determineFurtherQuestions={section?.determineFurtherQuestions}
        shouldSubmit={section?.isSubmit}
      />
    );
  });
};

export const HexpertSteps = () => {
  const { state, dispatch } = useContext(HexpertContext);

  const setStartSteps = (startPosition: HexpertState['startSteps']) => {
    dispatch({ type: 'setStartSteps', payload: startPosition });
  };

  return (
    <div
      className={classNames('c-hex-container c-hex-wizard-idle', {
        'c-hex-wizard-start': state?.startForm,
      })}
    >
      {state.showProductResult ? (
        <HexpertResultPage />
      ) : (
        <StepWizard
          isLazyMount
          transitions={custom}
          nav={
            <Stepper
              steps={
                state?.forceSteps
                  ? state?.forceSteps
                  : state?.currentForm?.sections
                  ? state?.currentForm?.sections?.length + 1
                  : 0
              }
              action={setStartSteps}
              currentStateStep={state?.startSteps}
            />
          }
        >
          {state?.startForm && !state?.startSteps && (
            <>
              <HexpertChooseType action={() => setStartSteps('start')} />
            </>
          )}
          {state?.currentForm &&
            state?.startForm &&
            formSections(state?.currentForm?.sections, setStartSteps)}
        </StepWizard>
      )}
    </div>
  );
};
